import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import config from '../../config/config'
import {ISingleDocument} from '../../services/utilis/ResponseObjects.types'
import SearchResultsSection from '../SearchResultsSection/SearchResultsSection'

interface ISearchResultsProps {
  documents: ISingleDocument[]|undefined,
}

const SearchResults = ({documents}: ISearchResultsProps) => {
  const {t} = useTranslation();

  const firstSectionDocuments = useMemo(() => documents?.filter(document => config.keyDocuments.includes(document.type)), [documents]);
  const secondSectionDocuments = useMemo(() => documents?.filter(document => config.otherDocuments.includes(document.type)), [documents]);

  const showSecondSection = secondSectionDocuments && secondSectionDocuments.length > 0;
  
  return (
    <>
      <SearchResultsSection title={t('search-section.main')} documents={firstSectionDocuments}/>
      {showSecondSection && <SearchResultsSection title={t('search-section.other')} documents={secondSectionDocuments}/>}
    </>
  )
}

export default SearchResults
